"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonContractConnector = void 0;
const TonContractFactory_1 = require("./TonContractFactory");
class TonContractConnector {
    constructor(contractType, network, address) {
        this.contractType = contractType;
        this.network = network;
        this.address = address;
    }
    async makeContract(contractFactory) {
        return await contractFactory.makeForExecute(this.network, this.address);
    }
    async getContract() {
        const contractFactory = new TonContractFactory_1.TonContractFactory(this.contractType);
        const contract = await this.makeContract(contractFactory);
        return this.network.open(contract);
    }
    async getBlockNumber(rpcUrl) {
        return (await this.network.api.getLastBlock()).last.seqno;
    }
}
exports.TonContractConnector = TonContractConnector;
//# sourceMappingURL=TonContractConnector.js.map